import styled from 'styled-components';

export const StyledContainerPage404 = styled.div`
  background-color: #F3F5F8;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  h2 {
    font-family: Poppins-Semi-Bold, sans-serif;
    font-size: 36px;
    color: #707070;
    margin-top: 5px;
    margin-bottom: -5px;
  }
  
  p {
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-size: 25px;
    color: #8B8C99;
  }
  
  svg {
  	width: 120px;
  	
  	path {
  		fill: #F80825;
  	}
  }
`;
